import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { vkPushEvent, ymPushEvent, ymPushParams } from '@fttb/common/utils';
import { VkGoalEvent } from "../../CatalogPage/blocks/constants";
import { PAGE_TYPE } from "./consts";
export var sendAnalytic = function sendAnalytic(analytic) {
  ymPushParams({
    fttb_order: analytic
  });
};
export var sendReachGoalYm = function sendReachGoalYm(_ref) {
  var tariff_name = _ref.tariff_name,
    form_type = _ref.form_type;
  ymPushEvent('HomeTariffConnectSuccess', {
    URL: window.location.href,
    tariff: tariff_name,
    form_type: form_type
  });
};
export var sendVkEventAnalytic = function sendVkEventAnalytic(pageType) {
  var goal = _defineProperty(_defineProperty({
    presetUp: VkGoalEvent.shpdTvIntOpenForm,
    homeInternetAndTv: VkGoalEvent.shpdTvOpenForm,
    homeInternet: VkGoalEvent.shpdOpenForm
  }, PAGE_TYPE.fttb_net, VkGoalEvent.shpdOpenForm), PAGE_TYPE.fttb_kit, VkGoalEvent.shpdTvOpenForm)[pageType];
  vkPushEvent(goal);
};
export var sendVkDetailsEventAnalytic = function sendVkDetailsEventAnalytic(pageType) {
  var goal = _defineProperty(_defineProperty(_defineProperty({}, PAGE_TYPE.fttb_net, VkGoalEvent.shpdLead), PAGE_TYPE.fttb_kit, VkGoalEvent.shpdTvLead), PAGE_TYPE.fttb_yandex, VkGoalEvent.shpdYandexLead)[pageType];
  vkPushEvent(goal);
};